import CommunityCard from './community-card';

export default CommunityCard;
